module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "product bps",
    class: {
      contrasted: _vm.isPageContrasted, fontBigger: _vm.isFontBigger
    }
  }, [_c('header', {
    staticClass: "page-header",
    attrs: {
      "data-aos": "fade-up"
    }
  }, [_c('div', {
    staticClass: "container"
  }, [(_vm.lang === 'pl') ? _c('div', {
    staticClass: "heading-text",
    attrs: {
      "data-aos": "fade-up"
    }
  }, [_vm._v("Kompleksowa ochrona ptaków wokół morskich farm wiatrowych")]) : _vm._e(), _vm._v(" "), (_vm.lang !== 'pl') ? _c('div', {
    staticClass: "heading-text",
    attrs: {
      "data-aos": "fade-up"
    }
  }, [_vm._v("Comprehensive protection of birds around offshore wind farms")]) : _vm._e(), _vm._v(" "), _c('p', {
    attrs: {
      "data-aos": "fade-up",
      "data-aos-delay": "100"
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "line",
    attrs: {
      "data-aos": "zoom-in-left",
      "data-aos-delay": "150"
    }
  }), _vm._v(" "), _c('p', {
    attrs: {
      "data-aos": "fade-up",
      "data-aos-delay": "200"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "why-us-solution",
    attrs: {
      "id": "top"
    }
  }, [_c('div', {
    staticClass: "elements"
  }, [_c('div', {
    staticClass: "element bps clearfix"
  }, [_c('div', {
    staticClass: "text-box"
  }, [(_vm.lang === 'pl') ? _c('ul', [_vm._m(0), _vm._v(" "), _vm._m(1), _vm._v(" "), _vm._m(2), _vm._v(" "), _vm._m(3), _vm._v(" "), _vm._m(4)]) : _vm._e(), _vm._v(" "), (_vm.lang !== 'pl') ? _c('ul', [_vm._m(5), _vm._v(" "), _vm._m(6), _vm._v(" "), _vm._m(7), _vm._v(" "), _vm._m(8), _vm._v(" "), _vm._m(9)]) : _vm._e()])])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('li', [_c('span', {
    staticClass: "dot"
  }), _vm._v(" "), _c('span', {
    staticClass: "text"
  }, [_vm._v("\n                Bioseco Spółka Akcyjna realizuje projekt z udziałem wsparcia UE pod tytułem:\n                „Kompleksowa ochrona ptaków wokół morskich farm wiatrowych - implementacja sztucznej inteligencji w rozproszonej sieci sensorów”.\n                "), _c('br')])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('li', [_c('span', {
    staticClass: "dot"
  }), _vm._v(" "), _c('span', {
    staticClass: "text"
  }, [_vm._v("\n                  Celem modułu B+R jest realizacja prac badawczych, nad pierwszym w Polsce systemem ochrony awifauny na morskich farmach wiatrowych opartym na rozproszonej sieci sensorów, połączonych oprogramowaniem opartym na algorytmach sztucznej inteligencji. Badania umożliwia opracowanie prototypu rozwiązania – urządzenia do detekcji ptaków w ekstremalnie trudnych warunkach morskich, zapobiegających kolizjom elektrowni z ptakami. \n                  Efektem prac będzie system ochrony ptaków: Offshore Bird Protection System.\n                  Grupą docelowe rozwiązania są inwestorzy i operatorzy farm wiatrowych na morzu.\n                  "), _c('br')])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('li', [_c('span', {
    staticClass: "dot"
  }), _vm._v(" "), _c('span', {
    staticClass: "text"
  }, [_vm._v("\n                  Efekty projektu będą komercjalizowane poprzez uczestnictwo w targach na rynkach zagranicznych, w ramach modułu Internacjonalizacja.\n                  "), _c('br')])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('li', [_c('span', {
    staticClass: "dot"
  }), _vm._v(" "), _c('span', {
    staticClass: "text"
  }, [_vm._v("\n                  Projekt współfinansowany jest z Europejskiego Funduszu Rozwoju Regionalnego w ramach programu: Fundusze Europejskie dla Nowoczesnej Gospodarki, "), _c('br'), _vm._v("\n                  Priorytet 1: „Wsparcie dla przedsiębiorców”"), _c('br'), _vm._v("\n                  Działanie: Ścieżka SMART"), _c('br'), _vm._v("\n                  Umowa o dofinansowanie nr FENG.01.01-IP.02-0673/24\n                  "), _c('br'), _c('br')])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('li', [_c('span', {
    staticClass: "text"
  }, [_c('br'), _vm._v("\n                Wartość projektu:"), _c('br'), _vm._v("\n                21 537 216,50 zł\n                "), _c('br'), _c('br'), _vm._v("\n                Dofinansowanie projektu ze środków UE:"), _c('br'), _vm._v("\n                14 333 627,00 zł\n              ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('li', [_c('span', {
    staticClass: "dot"
  }), _vm._v(" "), _c('span', {
    staticClass: "text"
  }, [_vm._v("\n                Bioseco Spółka Akcyjna is implementing a project with the support of the European Union entitled:\n                “Comprehensive protection of birds around offshore wind farms – implementation of artificial intelligence in a distributed sensor network.”\n                "), _c('br')])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('li', [_c('span', {
    staticClass: "dot"
  }), _vm._v(" "), _c('span', {
    staticClass: "text"
  }, [_vm._v("\n                The objective of the R&D module is to carry out research work on the first system in Poland for the protection of avifauna at offshore wind farms, based on a distributed network of sensors integrated with software using artificial intelligence algorithms. The research will enable the development of a prototype solution - a device for detecting birds in extremely challenging offshore conditions, aimed at preventing collisions between wind turbines and birds.\n                The outcome of the work will be a bird protection system: Offshore Bird Protection System.\n                The target group for the solution consists of investors and operators of offshore wind farms\n                  "), _c('br')])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('li', [_c('span', {
    staticClass: "dot"
  }), _vm._v(" "), _c('span', {
    staticClass: "text"
  }, [_vm._v("\n                The project results will be commercialized through participation in international trade fairs as part of the Internationalization module.\n                  "), _c('br')])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('li', [_c('span', {
    staticClass: "dot"
  }), _vm._v(" "), _c('span', {
    staticClass: "text"
  }, [_vm._v("\n                The project is co-financed by the European Regional Development Fund under the programme: European Funds for Smart Economy,"), _c('br'), _vm._v("\n                Priority 1: „Support for entrepreneurs”"), _c('br'), _vm._v("\n                Measure: SMART Path"), _c('br'), _vm._v("\n                Grant agreement no. FENG.01.01-IP.02-0673/24\n                  "), _c('br'), _c('br')])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('li', [_c('span', {
    staticClass: "text"
  }, [_c('br'), _vm._v("\n                Project value:"), _c('br'), _vm._v("\n                PLN 21 537 216,50\n                "), _c('br'), _c('br'), _vm._v("\n                EU funding for the project:"), _c('br'), _vm._v("\n                PLN 14,333,627.00\n              ")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-4d0646b0"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/Offshore.vue
// module id = 293
// module chunks = 0